import { baseApi } from "../baseApi";

export const examApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getUserExams: builder.query({
      query: (params = {}) => ({
        url: "/exams",
        params,
      }),
      providesTags: ["UserExams"],
    }),
    getUserExamById: builder.query({
      query: (id) => `/exams/${id}`,
      providesTags: ["UserExams"],
    }),
    startExam: builder.mutation({
      query: (id) => {
        return {
          url: `/exams/${id}/start`,
          method: "POST",
        };
      },
    }),
    chooseAnswer: builder.mutation({
      query: ({attemptId, body}) => {
        console.log("body", body);
        return {
          url: `/exams/attempts/${attemptId}/answer`,
          method: "POST",
          body: body,
        };
      },
    }),
    heartbeatExamAttempt: builder.mutation({
      query: ({ attemptId, body }) => ({
        url: `/exams/attempts/${attemptId}/heartbeat`,
        method: "POST",
        body,
      }),
    }),
    restartExam: builder.mutation({
      query: (attemptId) => {
        return {
          url: `/exams/attempts/${attemptId}/restart`,
          method: "POST",
        };
      },
      invalidatesTags: ["ExamAnalytics"],
    }),
    finishExam: builder.mutation({
      query: (attemptId) => {
        return {
          url: `/exams/attempts/${attemptId}/finish`,
          method: "POST",
        };
      },
      invalidatesTags: ["ExamAnalytics"],
    }),
    getExamAnalytics: builder.query({
      query: (params = {}) => ({
        url: `/exams/attempts/analytics`,
        params,
      }),
      // providesTags: ["UserExams"],
      providesTags: ["ExamAnalytics"],
    }),
    getExamAttemptById: builder.query({
      query: (attemptId) => `/exams/attempts/${attemptId}`,
      providesTags: ["ExamAttempt"],
    }),
  }),
});

export const {
  useGetUserExamsQuery,
  useLazyGetUserExamsQuery,
  useGetUserExamByIdQuery,
  useStartExamMutation,
  useRestartExamMutation,
  useFinishExamMutation,
  useChooseAnswerMutation,
  useHeartbeatExamAttemptMutation,
  useGetExamAnalyticsQuery,
  useLazyGetExamAnalyticsQuery,
  useGetExamAttemptByIdQuery,
  useLazyGetExamAttemptByIdQuery,
} = examApi;
